const FixedPaymentInput = ({ account, value, onChange, disabled }) => {
    const handleChange = (e) => {
        onChange(e.target.value);
    };

    return (
        <div className="formField">
            <label>Fixed Amount:&nbsp;</label>
            <input
                value={value || ''}
                type="number"
                min={account.minFixedAmount || 0}
                onChange={handleChange}
                disabled={disabled}
                style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '1rem'
                }}
            />
        </div>
    )
}

export default FixedPaymentInput